import {GeoCategoryTable} from '@widgets/category';

export const GeoCategoriesPage = () => {
  return <GeoCategoryTable />;
};
